export default __webpack_public_path__ + "static/media/calendar.c617af40.svg";